import React from "react";
import Footer from "react-bulma-components/lib/components/footer";
import "../../styles/footer.css";

export default class FooterResponsive extends React.Component {
    render() {

        const ShareLinks = [
            {name: 'Privacy and Data Policy', link: '/privacy-and-data-policy'},
            {name: 'Terms and Conditions', link: '/terms-and-conditions'},
            {name: 'Support', link: '/support'},
            {name: 'FAQs & Help Center', link: '/faqs'}
            // { name: 'Use of cookies', link: '#' }
        ];

        const SocialLinks = [
            {name: 'Facebook', link: 'https://www.facebook.com/yourmasterpieces/'},
            // { name: 'Twitter', link: '#' },
            {name: 'Instagram', link: 'https://www.instagram.com/yourmasterpieces/?hl=en'},
            {name: 'Youtube', link: 'https://www.youtube.com/channel/UCIejbLItmDDMzmbDErRffWw'},
            {name: 'Linkedin', link: 'https://www.linkedin.com/company/yourmasterpieces/'}
        ];

        return (

            <div>
                <Footer>
                    <div className="container footer-container">
                        <div className="row pull-left">

                            <div className="col-md-4 float-md-right float-sm-left pl-0">

                                <div className="sidebar-title">
                                    <h3 className="footer-heading">WHO WE ARE</h3>
                                    <span className="footer-text-seperator"></span>
                                </div>

                                <div className="who-we-are-content-golden font-14 footer-who-text sm-bottom-5">
                                    Started in 2016, the YourMasterpieces community now has over 20K artists across 142
                                    countries and grows stronger every day.
                                </div>

                                <div className="who-we-are-content-gray font-14 footer-who-text mb-15">
                                    YourMasterpieces is the first and only social platform for the non-digital fine art
                                    community with a vision to help artists to reach a global audience both digitally
                                    and tangibly. Artists, art collectors, art galleries, art educators and everyone who
                                    loves art have joined the platform.
                                </div>

                            </div>


                            <FooterSubmenuLinks title="Links" list={ShareLinks}/>

                            <FooterSubmenuLinks title="Social" list={SocialLinks}/>


                            <div className="col-md-4 float-md-right float-sm-left">

                                <div className="col-md-12">
                                    <div className="col-md-offset-1 footer-logo">
                                        <img src={require('../../assets/footer_logo_png.png')}
                                             className="footer-logo-image float-md-right float-sm-left"/>
                                    </div>
                                </div>

                                <div className="col-md-12 pr-0">
                                    <div className="copyright-text float-md-right float-sm-left">
                                        Copyright © 2021. {` `}YourMasterpieces<br/>
                                        All rights reserved.
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                </Footer>

                <div className="footer-secondary">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7 same-row border-vertical-footer">
                                <h3 className="footer-sec-text">
                                    Download YourMasterpieces on mobile
                                </h3>
                                <div className="both-image">
                                    <a href="https://play.google.com/store/apps/details?id=com.codon.masterpiece&hl=en_IN"
                                       target="_blank">
                                        <img src={require('../../assets/footer_playstore.svg')}
                                             className="footer-store-icon"/>
                                    </a>
                                    <a href="https://apps.apple.com/in/app/yourmasterpieces/id1089890769"
                                       target="_blank">
                                        <img src={require('../../assets/footer_appstore.svg')}
                                             className="footer-store-icon"/>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-5 same-row">
                                <h3 className="footer-sec-text ml-15">
                                    Payments by
                                </h3>
                                <img src={require('../../assets/payment_icons.png')} className="payment-icons"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )

    }
}

const FooterSubmenuLinks = (props) => {
    let {title, list} = props;

    return (
        <div className="col-md-2 ws-footer-col text-center">
            <div className="sidebar-title-center">
                <h3 className="footer-heading">{title}</h3>
                <span className="footer-text-seperator margin-center"></span>
            </div>
            <div className="menu-container text-lg-right text-md-right">
                <ul className="menu">
                    {
                        list.map((el, elIndex) => <li className="footer-submenu" key={elIndex}>
                            <a href={el.link}>{el.name}</a>
                        </li>)
                    }
                </ul>
            </div>
        </div>

    )
}


// WEBPACK FOOTER //
// ./src/components/layout/footer.js